import React from 'react';
import { Box } from '@wix/design-system';
const AIWrapperBase = ({ children, background, }) => {
    return (React.createElement(Box, { mixBlendMode: "multiply", width: "85%", direction: "vertical", gap: "SP4", borderRadius: "2px", background: background, paddingBottom: "SP3", paddingTop: "SP3", position: "relative" }, children));
};
export const AIWrapperSale = ({ children }) => {
    const background = 'linear-gradient(108deg, rgba(244, 227, 255, 0.50) 51.31%, rgba(251, 240, 233, 0.50) 90.07%)';
    return React.createElement(AIWrapperBase, { background: background }, children);
};
export const AIWrapperNonSale = ({ children }) => {
    const background = 'linear-gradient(108deg, rgba(5, 51, 255, 0.08) 48.69%, rgba(74, 202, 188, 0.10) 90.07%)';
    return React.createElement(AIWrapperBase, { background: background }, children);
};
//# sourceMappingURL=AIWrapper.js.map